module.exports = __webpack_public_path__ + "static/media/Article2.66c55693.webp";